import { useNavigate } from 'react-router-dom'
import notFound from '../../assets/404.png'
import './index.css'


export default function NotFound() {

  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/tickets/listing')
  }

  return (
    <>
      <div className='not-found-box'>
        <span>
          <img src={notFound} alt='not-found' />
        </span>
        <span>
          <h4>Página no encontrada</h4>
          <button className='not-found-btn' onClick={handleClick}>Volver</button>
        </span>
      </div>
    </>
  )
}